import React, { useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import { apiGet } from 'services';
import { limitOverTimeData } from '../../../../index';

import { Loading, Modal, StringHelpers, SystemText } from 'e4shared';

import Chart from 'chart.js';
import { e4Format, e4Formats } from 'helpers/dates';

let metricsOverTimeChart = null;

export const IntegrationOvertime = ({ profile, metric, range, show, close }) => {
    const guid = useSelector(state => (state.user.user ? state.user.user.guid : ''));
    const chartContainer = useRef(null);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    const user = useSelector(state => state.user.user);

    const st = (path, ...rest) => SystemText(`User121/Metrics/Overtime/${path}`, ...rest);

    const closeMe = () => {
        setData([]);
        setLoading(true);
        close();
    };

    React.useEffect(() => {
        profile &&
            show &&
            metric &&
            apiGet(`integration-overtime/${profile.id}/${metric.id}?range=${range}`, guid, response => {
                setLoading(false);
                setData(response);
            });
    }, [show, profile, metric, range, guid]);

    const metricFormat = metric?.format ? metric.format : 'X';

    const chartData = !metric
        ? {}
        : {
              id: 'canvas',
              type: 'bar',
              data: {
                  datasets: [
                      {
                          label: metric.legend,
                          data: limitOverTimeData(data, 'date_Set', 'amount').map(r => ({
                              x: r.date_Set,
                              y: r.amount,
                          })),
                          backgroundColor: 'rgba(99, 255, 132, 0.2)',
                          borderColor: 'rgba(99, 255, 132, 1)',
                          borderWidth: 1,
                      },
                  ],
              },
              options: {
                  tooltips: {
                      callbacks: {
                          title: function (tooltipItem, data) {
                              return e4Format(
                                  tooltipItem[0].xLabel,
                                  range === 'week' ? e4Formats.week : e4Formats.monthShort
                              );
                          },
                          label: function (tooltipItem, data) {
                              return StringHelpers.formatMetric(metricFormat, tooltipItem.yLabel, user.currencySymbol);
                          },
                      },
                  },
                  showLine: true,
                  legend: {
                      display: true,
                  },
                  scales: {
                      xAxes: [
                          {
                              type: 'time',
                              time: {
                                  unit: 'month',
                              },
                          },
                      ],
                      yAxes: [
                          {
                              name: metric.name,
                              position: 'left',
                              ticks: {
                                  precision: 0,
                                  suggestedMin: 0,
                                  callback: function (label, index, labels) {
                                      return StringHelpers.formatMetric(metricFormat, label, user.currencySymbol);
                                  },
                              },
                              gridLines: { display: false },
                          },
                      ],
                  },
              },
          };

    React.useEffect(() => {
        if (chartContainer?.current) {
            metricsOverTimeChart?.destroy();
            metricsOverTimeChart = new Chart(chartContainer.current, chartData);
        }
    }, [data, chartContainer, chartData]);

    return (
        <Modal
            data-testid="modal-integration-over-time"
            show={show}
            close={closeMe}
            title={st('Title', metric?.integration)}
        >
            {!loading ? (
                data && data.length > 0 ? (
                    <canvas data-testid="chart-integration-over-time" ref={chartContainer} width="100%" height="50%" />
                ) : (
                    <div>Sorry, no data is available</div>
                )
            ) : (
                <Loading />
            )}
        </Modal>
    );
};

export default IntegrationOvertime;
